import { sinkListItem, wrapInList } from 'prosemirror-schema-list';
import { findParentNode } from 'prosemirror-utils';

import { isList, isTable } from '../../utils';

export const tabToggleList = (state: any, dispatch: any) => {
  const { schema, selection } = state;
  const nodes = state.config.schema.nodes;
  const { $from, $to } = selection;
  const range = $from.blockRange($to);

  if (!range) {
    return false;
  }

  const parentList = findParentNode((node) => isList(node, schema))(selection);
  const parentTable = findParentNode((node) => isTable(node, schema))(selection);

  if (parentList) {
    if (range.depth >= 1 && range.depth - parentList.depth <= 1) {
      return sinkListItem(nodes.list_item)(state, dispatch);
    }

    return wrapInList(parentList.node as any)(state, dispatch);
  } else if (parentTable) {
    // Table Node has a corresponding KeyMap for Tab key. So we will propagate
    // event further.
    return false;
  }
  const { tr } = state;
  dispatch(tr.insertText('  ', selection.from, selection.to));
  // Returning true because we have handled this case and don't want ProseMirror
  // to propagate event further.
  return true;
};
